module.exports = __webpack_public_path__ + "static/media/banner.da40c827.jpg";